export const newsData = [
   


  {
  id: 4,
  slug: "sjkghnsd",
  title: "345345",
  category: "Turnering",
  img: "/113.png",
  desc: "Forstå den digitale verden, der former vores børn og unge Hvordan påvirker gaming, sociale platforme og online fællesskaber vores unge Og hvordan kan vi som forældre og fagpersoner støtte dem i at færdes trygt, nysgerrigt og ansvarligt.",
  date: "2025-12-14",
  content: `
<div class="event-layout">

  <!-- === SEKTION 1 — TEKST + FAKTA BOKS === -->
<div class="event-row">

  <!-- VENSTRE: TEKST -->
  <article class="event-article">
    <h3>Et inspirerende og lærerigt arrangement på Frederiksberg</h3>
    <p>
      Linx Legacy Academy inviterede forældre og unge til en spændende aften på 
      <strong>Nyelandsvej 51</strong> — en aften dedikeret til at forstå børn og unges digitale liv.
    </p>
    <p>
      Formålet er at skabe <strong>forståelse, indsigt og tryghed</strong> omkring gaming, sociale fællesskaber 
      og digital trivsel.
    </p>
    <p>
      Gæster møder både fagfolk, gamere og pædagogiske specialister samt prøv-selv stationer.
    </p>
  </article>

  <!-- HØJRE: FAKTA -->
  <aside class="event-info-box">
    <h4>Event Fakta</h4>
    <ul>
      <li><strong>Sted:</strong> Nyelandsvej 51, 2000 Frederiksberg</li>
      <li><strong>Dato:</strong> 14. December 2025</li>
      <li><strong>Tidspunkt:</strong> 12:00 - 18:00</li>
      <li><strong>Type:</strong> Offentligt event</li>
      <li><strong>Pris:</strong> Gratis</li>
      <li><strong>Arrangør:</strong> Linx Legacy Academy</li>
    </ul>
  </aside>

</div>


  <!-- === SEKTION 2 — TEKST + PROGRAM === -->
  <div class="event-row">

  <!-- VENSTRE: TEKST -->
  <article class="event-article">

    <h3>Digital Dannelse & Ansvarlig Online Adfærd</h3>
    <p>
      Vi arbejder med digitale fodspor, god kommunikation, konflikter
      og tryghed i onlinefællesskaber.
    </p>

    <h3>Digital Trivsel & Online Relationer</h3>
    <p>
      Vi undersøger hvordan online fællesskaber påvirker trivsel — positivt og negativt.
    </p>

    <h3>Gaming mod ensomhed</h3>
    <p>
      Gaming binder unge sammen og skaber netværk — også for dem som føler sig alene.
    </p>

    <h3>Gaming som pædagogisk værktøj</h3>
    <p>
      Gaming udvikler samarbejde, strategi, problemløsning og teknologiforståelse.
    </p>

  </article>

  <!-- HØJRE: PROGRAM -->
  <aside class="event-program-box">
    <h4>Program</h4>

    <div class="program-item">
      <span>12:00</span> Velkomst & intro
    </div>

    <div class="program-item">
      <span>12:30</span> Workshop: Digital Dannelse
    </div>

    <div class="program-item">
      <span>13:30</span> Gaming & trivsel — oplæg af Mathias
    </div>

    <div class="program-item">
      <span>15:00</span> Prøv-selv gaming stationer
    </div>

    <div class="program-item">
      <span>17:00</span> Q&A + afrunding
    </div>
  </aside>

</div>

`
  },
  


  {
    id: 3,
    slug: "Linx-Legacy-i-Esportligaen",
    title: "Så starter Esportligaen",
    category: "Turnering",
    img: "/ESPORTS1.png",
    desc: "Linx Legacy deltager i den kommende sæson af Esportligaen med et stærkt CS2-hold.",
    date: "2025-09-25",
    content: `
<h3>Et nyt kapitel i Linx Legacy’s rejse</h3>
<p>
Linx Legacy er klar til at tage endnu et skridt frem i dansk esport, når vi i år stiller op i <strong>Esportligaen 2025</strong>. 
Efter en intens træningsperiode og solid holdopbygning gennem sommeren, er vores CS2-hold mere fokuseret end nogensinde før. 
Dette bliver en mulighed for at vise, hvordan dedikation, fællesskab og strategi går hånd i hånd, når vi repræsenterer akademiet på den nationale scene.
</p>

<h3>Fokus på samarbejde og udvikling</h3>
<p>
Deltagelsen i Esportligaen handler ikke kun om at vinde – men om at lære, udvikle og vokse sammen som hold. 
Vores spillere har gennemgået en målrettet træningsplan med både teknisk træning, kommunikationsøvelser og fysisk aktivitet, 
for at sikre den bedst mulige præstation, når det virkelig gælder.
</p>

<h3>Præmier og hæder på spil</h3>
<p>
I Esportligaen 2025 kæmpes der om mere end bare ære. De bedste hold i Danmark dyster om:
</p>
<ul>
  <li>🏆 En samlet præmiepulje på <strong>50.000 kr.</strong></li>
  <li>🎟️ Direkte kvalifikation til internationale turneringer</li>
</ul>

<h3>Hold øje med os!</h3>
<p>
Du kan følge vores kampe og opdateringer her på hjemmesiden eller på vores sociale medier, hvor vi deler kampresultater, interviews 
og behind-the-scenes indhold. 
Sæsonen bliver intens, men vi er klar – og vi glæder os til at repræsentere <strong>Linx Legacy</strong> i Esportligaen 2025!
</p>

    `
  },



  {
    id: 2,
    slug: "Linx-Legacy-spiller-dust2-s30",
    title: "Linx Legacy spiller dust2 S30",
    category: "Turnering",
    img: "/POWERS30.png",
    desc: "Linx Legacy deltager i den prestigefyldte Dust2 S30 turnering med vores bedste CS2-hold.",
    date: "2025-09-23",
    content: `
<h3>Endnu en milepæl for Linx Legacy</h3>
<p>
Linx Legacy tager endnu et skridt op på den danske esportscene, når vi deltager i <strong>Dust2’s Sæson 30</strong> — 
en af de mest prestigefyldte Counter-Strike 2-turneringer i Danmark. 
Vores hold har arbejdet intenst gennem de sidste måneder for at nå dette niveau, og vi er stolte af at repræsentere både 
vores akademi og fællesskab i denne sæson.
</p>

<h3>Hård konkurrence og store ambitioner</h3>
<p>
Dust2 S30 samler nogle af landets bedste hold, hvor både semi-professionelle og etablerede organisationer kæmper om hæder og 
præmier. 
For Linx Legacy er det en mulighed for at vise, at vores filosofi om <em>træning, disciplin og holdånd</em> kan måle sig med de største.  
</p>

<h3>Holdet er klar</h3>
<p>
Vores CS2-hold har brugt de seneste uger på intensive træningssessions, strategiudvikling og bootcamps, 
hvor coach-teamet har finpudset kommunikation og taktik. 
Spillerne er klar – og motivationen er på sit højeste.
</p>

<h3>Følg vores rejse</h3>
<p>
Du kan følge vores kampe og resultater på både <strong>linxlegacy.dk</strong> og <strong>Dust2.dk</strong>, 
hvor vi løbende deler kampplaner, highlights og interviews.  
Følg os også på Discord og Instagram, hvor du kan få et kig bag kulisserne på, hvordan et akademi arbejder under pres.
</p>
    `
  },

      {
    id: 1,
    slug: "velkommen-til-linx-legacy-talent",
    title: "Velkommen til Linx Legacy Talent",
    category: "Academy",
    img: "/talent1.png",
    desc: "Linx Legacy byder velkommen til sit nye talenter",
    date: "2025-09-12",
    content: `
<h3>Et nyt kapitel begynder</h3>
<p>
Det er med stolthed, at vi præsenterer det nye <strong>Linx Legacy Talent-hold</strong> — 
en samling af unge, dedikerede spillere, der skal repræsentere fremtiden for organisationen.  
Dette markerer starten på en ny æra, hvor udvikling, teamwork og sulten efter succes står i centrum.
</p>

<h3>5 spillere. 1 Legacy.</h3>
<p>
Vores talenthold består af fem ambitiøse spillere, som hver især bringer unikke styrker til serveren:
</p>

<ul>
  <li>🎯 <strong>@Narno_DK</strong></li>
  <li>🔥 <strong>@Olicsa06</strong></li>
  <li>💪 <strong>@b0ggi_cs</strong></li>
  <li>⚡ <strong>@karlkanics</strong></li>
  <li>💥 <strong>@1senz_</strong></li>
</ul>

<h3>Formålet med Linx Legacy Talent</h3>
<p>
Formålet med vores talenthold er klart:  
at skabe et miljø, hvor unge spillere kan udvikle sig både individuelt og som team — med støtte fra erfarne coaches og moderne træningsmetoder.  
Hos Linx Legacy tror vi på, at vejen til toppen starter med de rigtige værdier: <strong>fællesskab, disciplin og passion</strong>.
</p>

<h3>Vejen frem</h3>
<p>
Talentholdet vil deltage i kommende nationale turneringer, træningsbootcamps og interne udviklingsforløb gennem Linx Legacy Academy.  
Der vil løbende blive delt opdateringer, interviews og kampresultater på vores platforme.
</p>
    `
  },





];
